import Vue from 'vue';

const success = (context, response, event, booking) => {
  if (event === 'payment') {
        booking.payment_is_done = response.payment_is_done;
        context.paymentStatus = response.payment_is_done ? 'OK' : 'KO';
        booking.status = response.status;
  } else if (event === 'deposit') {
        context.depositStatus = response.deposit_is_done ? 'OK' : 'KO';
        booking.deposit_is_done = response.deposit_is_done;
  }
  toastr.success(context.$t('payments.status_change'));
};

const failed = (context, error) => {
  context.showToasterError(error);
};

export default (context, data, event, booking) => Vue.$http.post('/booking/change-event-statuses-web', data)
    .then((response) => {
      if (response && response.status === 200) {
        success(context, response.data, event, booking);
      }
    }).catch((error) => {
      failed(context, error);
    });



// WEBPACK FOOTER //
// ./src/app/services/booking/changeEventStatuses.js